/** Equipes de atendimento: quem esta junto e atende as mesmas filas. */
export const nav = {
    permissao: 'atendimento.equipes:ver',
    section: 'Configuracao',
    title: 'Equipes',
    icon: 'groups',
    route: '/equipes',
    sequence: 11,
};

export default [
    {
        path: '/equipes',
        name: 'equipes',
        component: () => import('./pages/EquipesPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.equipes:ver' },
    },
];
